<template>
    <div>
        <v-row>
            <v-col>
                <h4 class="text-h4">Journal Vouchers</h4>
                <p class="text-subtitle-1">Journal Vouchers list</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-sheet>
                <v-toolbar flat dense>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn
                            icon
                            v-if="journalVouchers.length"
                            @click="openJournalEntryListPrintDialogProps">
                            <v-icon>mdi-printer</v-icon>
                        </v-btn>
                        <v-btn
                            icon
                            @click="refreshDataFetch">
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                        <v-btn 
                            v-if="selected.journalEntry.length"
                            @click="openJournalEntryDisplayDialog()"
                            icon>
                            <v-icon>mdi-eye</v-icon>
                        </v-btn>
                        <v-btn 
                            v-if="selected.journalEntry.length"
                            @click="handleCopyingJournalVoucher"
                            icon>
                            <v-icon>mdi-content-copy</v-icon>
                        </v-btn>
                        <v-menu
                            offset-y
                            :close-on-content-click="false"
                            v-model="menuDisplay"
                            >
                            <template v-slot:activator="{on: menu}">
                                <v-tooltip bottom="">
                                    <template v-slot:activator="{on: tooltip}">
                                        <v-btn
                                            icon
                                            v-on="{...menu, ...tooltip}"
                                            >
                                            <v-icon>mdi-magnify</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Search</span>
                                </v-tooltip>
                            </template>
                            <p-search-menu
                                :show="{ 'code': true, 'data_to': true, 'data_from': true , 'user': true, 'post': true}"
                                @search="onSearchData">
                            </p-search-menu>
                            <!-- <v-text-field
                                label="Search"
                                solo
                                hide-details>
                            </v-text-field> -->
                        </v-menu>
                        <v-menu
                            offset-y>
                            <template v-slot:activator="{on}">
                                <v-btn
                                    icon
                                    v-on="on"
                                    >
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list width="250" dense>
                                <v-list-item
                                    @click="openJournalEntryDialog({ editMode: false })"
                                    link>
                                    <v-list-item-icon>
                                        <v-icon>mdi-database-plus</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>{{ $t('new_journal_entry') }}</v-list-item-title>
                                </v-list-item>
                                <v-divider v-if="selected.journalEntry.length"></v-divider>
                                <v-list-item
                                    v-if="selected.journalEntry.length"
                                    @click="openJournalEntryDisplayDialog()"
                                    link>
                                    <v-list-item-icon>
                                        <v-icon>mdi-eye</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>{{ $t('show_journal_entry') }}</v-list-item-title>
                                </v-list-item>

                                <v-list-item
                                    v-if="selected.journalEntry.length"
                                    :disabled="!selected.journalEntry[0].meta.editable"
                                    @click="openJournalEntryDialog({ editMode: true, id: selected.journalEntry[0].id })"
                                    link>
                                    <v-list-item-icon>
                                        <v-icon :disabled="!selected.journalEntry[0].meta.editable">mdi-pencil</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>{{ $t('edit_journal_entry') }}</v-list-item-title>
                                </v-list-item>
                                
                                <v-list-item
                                    v-if="selected.journalEntry.length"
                                    :disabled="!selected.journalEntry[0].meta.deletable"
                                    @click="openDeleteSingleDialog({target: 'journalEntries', id: selected.journalEntry[0].id})"
                                    link>
                                    <v-list-item-icon>
                                        <v-icon :disabled="!selected.journalEntry[0].meta.deletable">mdi-delete</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>{{ $t('delete_journal_entry') }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar-items>
                </v-toolbar>
                <v-data-table
                    dense
                    single-select
                    show-select
                    @item-selected="setSelectedFormcheckBox"
                    @click:row="setSelected"
                    @dblclick:row="openJournalEntryDisplayDialog"
                    v-model="selected.journalEntry"
                    :loading="loading.data"
                    :items="journalVouchers"
                    :server-items-length="journalLength"
                    :options.sync="options"
                    :footer-props="{ 'items-per-page-options': [5,10,15,50,100] }"
                    :headers="headers.journalEntry">
                    <template v-slot:[`item.total`]="{item}">
                        {{ formatMoney(item.total, item.base_currency+` `, 2) }}
                    </template>
                    <template v-slot:[`item.reference`]="{ item }">
                        <p-table-width :row="item.reference" :length="15"></p-table-width>
                    </template>
                    <template v-slot:[`item.narration`]="{ item }">
                        <p-table-width :row="item.narration" :length="30"></p-table-width>
                    </template>
                    <template v-slot:[`item.status`]="{ item }">
                        <p-status :state="item.status"></p-status>
                        <!-- <v-badge dot :color="getColor(item.status)" inline left></v-badge>{{ item.status }} -->
                        <!-- <v-chip small :color="getColor(item.status)" dark></v-chip> -->
                    </template>
                </v-data-table>
            <JournalEntryDialog
                v-if="journalEntryDialogProps.display"
                v-model="journalEntryDialogProps.display"
                :id="journalEntryDialogProps.id"
                :copy="journalEntryDialogProps.copy"
                @close="closeJournalEntryDialog"
                @submit="createdDataFetch"/>
            <RetryDialog
                ref="retryDialog"
                @submit="onRetryDialogSubmit"/>
            <JournalEntryDisplayDialog
                v-if="journalEntryDisplayDialogProps.display"
                v-model="journalEntryDisplayDialogProps.display"
                :id="journalEntryDisplayDialogProps.id"
                @close="closeJournalEntryDisplayDialog"
                ref="journalEntryDisplayDialog"/>
            <delete-single-dialog
                @submit="onDeleteDialogSubmit"
                ref="deleteSingleDialog">
            </delete-single-dialog>
            <alert-dialog ref="alertDialog"></alert-dialog>
            <journal-entry-list-print-dialog
                :search="search"
                v-if="journalEntryListPrintDialogProps.display"
                :journalEntryList="journalEntryListPrintDialogProps.journalVouchers"
                @close="closeJournalEntryListPrintDialogProps">
            </journal-entry-list-print-dialog>
            <PAlert v-model="alertShown" v-bind="alert"/>
        </v-sheet>
    </div>
</template>
<script>
import JournalEntryDisplayDialog from '@/components/accounting/JournalEntryDisplayDialog';
import RetryDialog from '@/components/common/RetryDialog';
import JournalEntryDialog from '@/components/accounting/JournalEntryDialog';
import { mapActions, mapState } from 'vuex';
import {formatMoney} from 'accounting';
import DeleteSingleDialog from '../../components/common/DeleteSingleDialog.vue';
import AlertDialog from '../../components/common/AlertDialog.vue';
import PSearchMenu from '@/components/common/PSearchMenu'
import JournalEntryListPrintDialog from '../../components/accounting/JournalEntryListPrintDialog.vue';
import PTableWidth from '../../components/common/PTableWidth.vue';
import truncate from '@/utils/truncate';
import getColor from '@/utils/getColor';
import PStatus from '../../components/common/PStatus.vue';
import PAlert from '../../components/common/PAlert';

export default {
    name: "JournalEntries",
    components: {
        JournalEntryDialog,
        PAlert,
        RetryDialog,
        JournalEntryDisplayDialog,
        DeleteSingleDialog,
        AlertDialog,
        PSearchMenu,
        JournalEntryListPrintDialog,
        PTableWidth,
        PStatus
    },
    data() {
        return {
            menuDisplay: false,
            journalLength: 0,
            selected: {
                journalEntry: []
            },
            headers: {
                journalEntry: [
                    { text: this.$t('code'), value: 'code' },
                    { text: this.$t('date'), sortable: false, fixed: true, value: 'journal_date' },
                    { text: this.$t('document_date'), fixed: true, value: 'document_date' },
                    { text: this.$t('reference'), fixed: true, value: 'reference' },
                    // { text: this.$t('type'), sortable: false, value: 'transaction_type' },
                    { text: this.$t('narration'), fixed: true, value: 'narration' },
                    // { text: this.$t('currency'), value: 'currency' },
                    { text: this.$t('total'), fixed: true, sortable: false, value: 'total' },
                    { text: this.$t('status'), sortable: false, value: 'status' }
                ] 
            },
            loading: {
                data: false
            },
            journalVouchers: [],
            journalEntryDialogProps: {
                id: null,
                display: false,
                copy: false
            },
            journalEntryDisplayDialogProps: {
                display: false,
                id: null
            },
            journalEntryListPrintDialogProps: {
                display: false,
                journalVouchers: []
            },
            options: {},
            search: {},
            alertShown: false,
            alert: {
                title: "",
                content: "",
                callback: null
            }
        }
    },
    computed: {
        ...mapState('accounting/journalEntry', ["journalEntries"]),
    },
    mounted: function () {
       this.$nextTick(function () {
           window.addEventListener('keydown', event => {
               if(event.altKey  && event.keyCode === 78){
                  this.openJournalEntryDialog({ editMode: false });
               }
           })
       });
   },
    watch: {
        options: {
            handler () {
                this.createdDataFetch();
            },
            deep: true
        }
    },
    methods: {
        formatMoney,
        truncate,
        getColor,
        ...mapActions('accounting/journalEntry', ["fetchJournalEntries"]),
        ...mapActions('accounting/journalVoucher', ["fetchJournalVouchers", "removeJournalVoucher"]),
        async createdDataFetch(){
            try {
                this.loading.data = true;
                // this.options.search = this.search;
                let result = await this.fetchJournalVouchers({...this.options,...this.search});
                this.journalVouchers = result.data.data;
                this.journalLength = result.data.total;
                this.loading.data = false;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target:"createdDataFetch",message});
            }
        },
        onSearchData(searchData) {
            this.selected.journalEntry = [];
            this.menuDisplay = false;
            this.search = searchData;
            this.createdDataFetch();
        },
        onRetryDialogSubmit(params){
            if(params.target == "createdDataFetch") {
                if(params.retry) this.createdDataFetch();
            }
        },
        handleCopyingJournalVoucher() {
            this.alertShown = true;
            this.alert = {...this.alert, title: "Are you sure?", content: "Journal Voucher will be copied. Do you want to continue?", callback: this.openJournalEntryCopyDialog}
        },
        openJournalEntryCopyDialog() {
            this.openJournalEntryDialog({ editMode: true, copy: true, id: this.selected.journalEntry[0].id })
        },
        openJournalEntryDialog({ editMode, id, copy }) {
            this.journalEntryDialogProps.id = editMode ? id : null;
            this.journalEntryDialogProps.display = true;
            this.journalEntryDialogProps.copy = copy;
        },

        closeJournalEntryDialog(){
            this.journalEntryDialogProps.display = false;
        },
        openJournalEntryDisplayDialog() {
            if(this.selected.journalEntry.length) {
                this.journalEntryDisplayDialogProps.id = this.selected.journalEntry[0].id;
                this.journalEntryDisplayDialogProps.display = true;
            }
        },
        openJournalEntryListPrintDialogProps() {
            this.journalEntryListPrintDialogProps.display = true;
            this.journalEntryListPrintDialogProps.journalVouchers = this.journalVouchers;
        },
        closeJournalEntryListPrintDialogProps() {
            this.journalEntryListPrintDialogProps.display = false;
        },
        closeJournalEntryDisplayDialog() {
            this.journalEntryDisplayDialogProps.display = false;
        },
        setSelectedFormcheckBox({ value, item }) {
            if(value) this.setSelected(item);
            else this.clearSelected();
        },
        clearSelected() {
            this.selected.journalEntry = [];
        },
        onDeleteDialogSubmit(params) {
            if(params.target == 'journalEntries') {
                this.removeJournalVoucher(params)
                    .then(() => {
                        this.$refs.deleteSingleDialog.close();
                        this.createdDataFetch();
                        this.$refs.alertDialog.open({type: "success", message: this.$t("records_delete_success")});
                    })
                    .catch((error) => {
                        this.$refs.deleteSingleDialog.close();
                        let message = error.response ? error.response.data.message : error;
                        this.$refs.alertDialog.open({type: "error", message});
                    })
            }
        },
        openDeleteSingleDialog(params) {
            this.$refs.deleteSingleDialog.open(params);
            this.selected.journalEntry = [];
        },
        setSelected(journalEntry) {
            this.clearSelected();
            this.selected.journalEntry.push(journalEntry);
        },
        refreshDataFetch() {
            // this.search = null;
            this.createdDataFetch();
        }
        
    },
    created () {
        // this.getJournalVoucher();
        // this.createdDataFetch();
    },
}
</script>